"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.computeUnitPrice = void 0;
var bignumber_js_1 = __importDefault(require("bignumber.js"));
var rounding_1 = require("../roundings/rounding");
var computeUnitPrice = function (products) {
    products.forEach(function (product) {
        Object.keys(product.unitPriceNotRounded).forEach(function (key) {
            product.unitPriceNotRounded[key] = new bignumber_js_1.default(product.totalPriceRounded[key]).dividedBy(new bignumber_js_1.default(product.quantity));
        });
        var pricesRoundedPartial = (0, rounding_1.roundItemValues)(product.unitPriceNotRounded);
        product.unitPriceRounded = (0, rounding_1.addTaxAmounts)(pricesRoundedPartial);
    });
};
exports.computeUnitPrice = computeUnitPrice;
